/*
 * @Author: 孙照
 * @LastEditTime: 2023-10-10 11:19:39
 * @Description: 大屏接口声明 首页
 * @FilePath: \sheyang\src\api\overView\index.js
 */
import request from '@/utils/request';

// 场站数量、坐标
export function getStationInfo (params = {}) {
  return request({
    url: '/webapi/saasIgnore/screen/monitor/stubGroup/map/qry',
    method: 'get',
    params,
  });
}

// 能源地图接口
export function getEnergyMap (params = {}) {
  return request({
    url: '/webapi/saasIgnore/screen/monitor/energy/map/qry',
    method: 'get',
    params,
  });
}

// 用电月列表 进一个月趋势分析
export function getMonthAnalyseData (params) {
  return request({
    url: '/webapi/saasIgnore/screen/monthAnalyseData',
    methods: '',
    params,
  });
}

// 累计充电量、累计充电次数、累计碳减排、累计光伏发电量、累计储能充电量、累计储能放电量
export function getPowerStatData (params) {
  return request({
    url: '/webapi/sheyang/saasIgnore/screen/dataStatistics',
    method: 'get',
    params,
  });
}

// 电站地图电站监控数据，单电站
export function getStationDetail (params) {
  return request({
    url: '/webapi/saasIgnore/screen/monitor/stubGroup/qry',
    method: 'get',
    params,
  });
}
